import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { auth_nav_path } from './views/auth/auth.module';
import { LayoutComponent } from '../shared/components/layout/layout.component';
import { publicStories_nav_path } from './views/stories/stories.module';
import { answers_nav_path } from './views/answers/answers.module';
import { portfolio_nav_path } from './views/portfolio/portfolio.module';

const COMPONENTS = []!;

export const public_nav_path = {
  home: '/',
  answers: '/answers', ...answers_nav_path,
  auth: '/auth', ...auth_nav_path,
  portfolio: '/portfolio', ...portfolio_nav_path,
  stories: '/stories', ...publicStories_nav_path
};
const routes: Routes = [
  { path: '', component: LayoutComponent, children: [
      { path: '', component: HomeComponent, outlet: 'primary', pathMatch: 'full' },
      { path: 'answers', loadChildren: () => import('./views/answers/answers.module').then(m => m.AnswersModule) },
      { path: 'portfolio', loadChildren: () => import('./views/portfolio/portfolio.module').then(m => m.PortfolioModule) },
      { path: 'stories', loadChildren: () => import('./views/stories/stories.module').then(m => m.PublicStoriesModule) }
    ]
  },
  { path: 'auth', loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule) },
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [RouterModule.forChild(routes)]
})
export class PublicModule { }
